import React, { useEffect } from 'react';
import { useUserProfile } from '../../helper/UserProfile';
import { useRevalidationData } from '../../helper/UserRevalidationProgress';
import '../../stylesheets/revalidation.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { downloadRevalidationZip } from '../../helper/RevalidationPortfolioDownload';
import MobileRevalNav from '../mobile/MobileRevalNav';

function RevalidationDocuments() {

  const { profile } = useUserProfile();
  const { phlHours, totalHours, selectedQualifications, feedback, reflective, refresh, phl, cpd } = useRevalidationData();

  useEffect(() => {
    if (refresh) refresh();
  }, []);

  return (
    <div>
      <MobileRevalNav />
      <div className="dashboard-body">
        <h2>REVALIDATION DOCUMENTS</h2>

        <div className="reval-grid">
          <div>
            <h3>YOUR PORTFOLIO SNAPSHOT</h3>
            <p>Here is your current revalidation log:</p>
            <ul style={{listStyle:"none", paddingLeft:"1rem"}}>
              <li>{totalHours >= 35 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}{totalHours}/35 CPD hours</li>
              <li>{phlHours >= (Number(selectedQualifications) * 450) ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}{phlHours}/{450 * Number(selectedQualifications)} practice hours</li>
              <li>{reflective.length >= 5 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}{reflective.length}/5 reflective accounts</li>
              <li>{feedback.length >= 5 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}{feedback.length}/5 pieces of feedback</li>
            </ul>
            <br></br>
            <button onClick={() => downloadRevalidationZip(profile, phl, cpd)} className="reval">
                Download Portfolio
            </button>
            
          </div>
        
          <div className="mob-block">
            <h3>DOCUMENT BANK</h3>        
            <p>Please find mandatory NMC templates below, as well as useful guides to help you complete your portfolio.</p>
            <h4>TEMPLATES</h4>
            <ul style={{paddingLeft: "1rem"}}>
              <li a href="/reflective-accounts-form.doc" download="Reflective Account Form.doc" className="clickable-link">Reflective Account Template</li>
              <li a href="/reflective-discussion-form.doc" download="Reflective Discussion Form.doc"  className="clickable-link">Reflective Discussion Template</li>
              <li a href="/confirmation-form.doc" download="Confirmation Form.doc" className="clickable-link">Confirmation Statement</li>
      
            </ul>
            <br></br>

            <h4>GUIDE</h4>
            <ul style={{paddingLeft: "1rem"}}>
              <li className="clickable-link"><a href="https://www.nmc.org.uk/globalassets/sitedocuments/revalidation/how-to-revalidate-booklet.pdf" target="_blank">NMC's Guide to Revalidation <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="xs" style={{paddingLeft: "5px"}}/></a></li>
              <li className="clickable-link"><a href="https://www.nmc.org.uk/standards/code/read-the-code-online/" target="_blank">NMC Code <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="xs" style={{paddingLeft: "5px"}}/></a></li>
              <li className="clickable-link"><a href="https://www.nmc.org.uk/standards/" target="_blank">NMC Standards <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="xs" style={{paddingLeft: "5px"}}/></a></li>
              
            </ul>
          </div>
        </div>
        <br></br>

      </div>
    </div>
  )
}

export default RevalidationDocuments